module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_2_back_pc_f2367874f51fda60a0e26be4f0d94455.jpg";